export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7918.fee85b86.jpg";